import React from 'react';
import PropTypes from 'prop-types';
import { Icon, Image } from 'semantic-ui-react';

const Content = ({
  pageTitle, iconName, isSidebarExtended, isActive, imgURL,
}) => (
  <div className="navlink-container">
    <div className="navlink-container-left" />
    <div className="navlink-container-center">
      <div className={`icon-group-left${isActive ? '-active' : ''} ${imgURL && 'padded'}`}>
        <Icon
          name={iconName}
          size="large"
        />
      </div>
      {isSidebarExtended
      && (
        <div className={`icon-group-right ${imgURL && 'padded'}`}>
          {imgURL
            ? (
              <Image src={imgURL} />
            )
            : (
              <span className="sidebar-text">{pageTitle}</span>
            )}
        </div>
      )}
    </div>
    <div className="navlink-container-right" />
  </div>
);

Content.propTypes = {
  isSidebarExtended: PropTypes.bool.isRequired,
  iconName: PropTypes.string.isRequired,
  pageTitle: PropTypes.string.isRequired,
  imgURL: PropTypes.string,
  isActive: PropTypes.bool,
};

Content.defaultProps = {
  isActive: false,
  imgURL: null,
};

export default Content;



// WEBPACK FOOTER //
// ./src/components/SidebarItem/Content.js